<template>
  <modal v-if="showConfirmModal" :id="options.modalId">
    {{ options.text }}
    <template slot="footer">
      <button type="button" class="btn btn-default" @click="onConfirmStatus(true)">
        {{ $i18n.t('modal_confirm') }}
      </button>
      <button type="button" class="btn btn-default" @click="onConfirmStatus(false)">
        {{ $i18n.t('modal_close') }}
      </button>
    </template>
  </modal>
</template>

<script>
/**
 * @param ConfirmModal component
 *
 * @description Mentést vagy oldal elhagyást elenörző megerősítő felugróablak
 */
import Modal from '../../modal/Modal'
import ModalOpener from '../../modal/Opener'
import EventBus from '../../../utils/event-bus'

export default {
  name: 'ConfirmModal',
  components: {
    Modal,
    ModalOpener,
  },
  computed: {
    options() {
      return this.$get('confirmOptions')
    },
    showConfirmModal() {
      return this.options.status
    },
  },
  methods: {
    close() {
      this.active = false
    },
    open() {
      this.$store.dispatch('showModal', this.options.modalId)
    },
    onConfirmStatus(status) {
      if (status && !!this.options.callBack) {
        eval(`this.${this.options.callBack}()`)
        this.$dispatch('setConfirmOption', {
          option: 'callback',
          value: null,
        })
      }
      this.$dispatch('setConfirmOption', { option: 'status', value: status })
      this.$store.dispatch('hideModal', this.options.modalId)
    },
  },
  mounted() {
    this.$nextTick(() => {
      EventBus.$on('open-confirm-modal', (event) => {
        if (event.target === this.options.modalId) {
          this.open()
        }
      })
    })
  },
  beforeDestroy() {
    EventBus.$off('open-confirm-modal')
  }
}
</script>
